let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1VmC7")).then(() => parcelRequire('9jt2S'));